module.exports = __webpack_public_path__ + "assets/svelte.dc4696cf.svg";